// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"89b22b5b6967b9740d8f","691":"6a28e99d06b1f12a5d6c"}[chunkId] + ".js";
};